import { connect } from 'react-redux';
import Company from './Company';

import { setHorizonLengthChange, setYearSliderChange } from '../../common/settings/actions';
import { getAnnualResults } from '../../Simulator/TabBar/Results/selectors';


const mapStateToProps = state => ({
    horizonLength: state.settings.horizonLength,
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
    inverter: state.solar.inverter,
    includeESS: state.ess.includeESS,
    resiToggle: state.tax.resiToggle,
    provider: state.utility.provider,
    projectState: state.projectaddress.projectState,
    setHorizonLengthChange,
    setYearSliderChange,
});

const combinedActions = {
    setHorizonLengthChange,
    setYearSliderChange,
};

export default connect(mapStateToProps, combinedActions)(Company);



// WEBPACK FOOTER //
// ./src/containers/Home/Company/index.js